/*
 * @Author: Rowe
 * @Date: 2019-03-21 15:26:25
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-08-28 15:48:01
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FooterCode from "./FooterCode";
import FooterMap from "./FooterMap";
import FooterDeclaration from "./FooterDeclaration";
import GoogleAnalytics from "../../Utils/GoogleAnalytics";
import { cookieGet } from "../../Utils";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerCode: "",
      footerMap: ""
    };
  }

  componentDidMount() {
    const _homeConfig = this.props._homeConfig;
    if(_homeConfig && _homeConfig.results && _homeConfig.results.welcomeTip){
      this.setState({
        footerCode: _homeConfig.results.followUsList,
        footerMap: _homeConfig.results.bottomLinkSectionList
      })
    }
  }
  /**
   *所有页面埋点 Default pageview update by andy
   *
   * @memberof Footer
   */
 
  render() {
    let Nodes = [];
    let { _View } = this.props;
    let { footerCode, footerMap } = this.state;
      if(!_View) {
        Nodes.push(<FooterCode footerCode={footerCode} key="FooterCode" />);
      }
      Nodes.push(<FooterMap footerMap={footerMap} key="FooterMap" />);
      Nodes.push(<FooterDeclaration key="FooterDeclaration" />);
    return (
      <div id="Footer">
        {Nodes}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    _homeConfig: state.homeConfig,
  }),
  (dispatch) => ({
    dispatch,
  })
)(Footer);



// WEBPACK FOOTER //
// ./common/components/Footer/index.js